export * from "-!../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./deposit.vue?vue&type=template&id=fd2e6ff8"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/branches/branch/bonuses/deposit.vue?vue&type=template&id=fd2e6ff8
// module id = tHIx
// module chunks = 0